import { render, staticRenderFns } from "./CRMBillDetails.vue?vue&type=template&id=edd45bfc&scoped=true&"
import script from "./CRMBillDetails.vue?vue&type=script&lang=js&"
export * from "./CRMBillDetails.vue?vue&type=script&lang=js&"
import style0 from "./CRMBillDetails.vue?vue&type=style&index=0&id=edd45bfc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edd45bfc",
  null
  
)

export default component.exports